import type { IBrandingTokens } from '../../branding';

const brandingTokens: IBrandingTokens = {
	application: 'dssi',
	standardButtonStyle: 'primary',
	sageLogo: '/images/OrangeDSSISageLeaf-small.png',
	useRecommendationsLogo: true,
};

export default brandingTokens;
